/****
 * a listing of partner programs.  Component is self contained and can
 * be put anywhere
 * TODO needs sorting, pagination, and probably a status filter.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import TabPageTitle from '../ui/TabPageTitle';
import AppLogo from '../ui/AppLogo';
import withStyles from '@mui/styles/withStyles';
import { Grid, Link, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Typography } from '@mui/material';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

const abEnvironment = new AbEnvironment();
const PartnerProgramsQuery = graphql`
query PartnerProgramsQuery($accountId: UUID!, $first: Int, $offset: Int) {
  allVppRTs(condition:{partnerId: $accountId},first: $first, offset: $offset) {
    totalCount 
    nodes 
    { 
      vppId 
      stage
      vppTByVppId { 
        programName 
        description
        accountTByVendorId { 
          accountName 
          logo 
        } 
      } 
    }
  } 
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  }
});

class PartnerPrograms extends Component {

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedReseller())
    {
      let accountId = abEnvironment.getUserAttribute('a_id');

      return (
        <div className={classes.root}>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={PartnerProgramsQuery}
            variables={{accountId: accountId, first: 10}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                

                let rprogs = [];
                let i = 0;
                for (i = 0; i < props.allVppRTs.totalCount; i++) {
                  rprogs.push(props.allVppRTs.nodes[i]);
                }

                if (props.allVppRTs.totalCount > 0) {
                  //lets sort the list by vendor name
                  rprogs.sort (function(a,b) {

                    let aStr = '' + a.vppTByVppId.accountTByVendorId.accountName;
                    let bStr = '' + b.vppTByVppId.accountTByVendorId.accountName;
                    return aStr.localeCompare(bStr);
                  });
                }

                let counter = 0;
                return (
                  <Grid container spacing={2} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                      <TabPageTitle title="Participating programs" />
                    </Grid>
                    <Grid item xs={12}>
                      {(rprogs == null || rprogs.length === 0) &&
                      <Typography variant="body2">You aren't registered for any partner programs yet.</Typography>
                      }
                      {(rprogs != null && rprogs.length > 0) &&
                      <Paper>
                        <TableContainer>
                          <Table>
                            <TableHead className={classes.tblHead}>
                              <TableRow className={classes.tblHeadRow}>
                                <TableCell>Vendor</TableCell>
                                <TableCell>Program</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Status</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rprogs.map(n => {
                                let programName = n.vppTByVppId.programName;
                                let description = n.vppTByVppId.description;
                                let vendorName = n.vppTByVppId.accountTByVendorId.accountName;
                                let vendorLogo = n.vppTByVppId.accountTByVendorId.logo;
                                let aUrl = 'vendorpartnerprogram?vppId=' + n.vppId;
                                let status = 'Not applied yet';
                                //0: Lead.  1: Applied. 2: Active. 3: Suspended.  4: Rejected.  5: Left
                                if (n.stage === 1) {
                                  status = 'Applied';
                                } else if (n.stage === 2) {
                                  status = 'Active';
                                } else if (n.stage === 3) {
                                  status = 'Suspended';
                                } else if (n.stage === 4) {
                                  status = 'Declined';
                                } else if (n.stage === 5) {
                                  status = 'Left';
                                }

                                return (
                                  <TableRow key={counter++ }>
                                    <TableCell>
                                      <Grid container alignItems="center" spacing={1}>
                                        <Grid item>
                                          <AppLogo logoPath={vendorLogo} appName={vendorName} imageHeight='24px' theStyle={{marginRight: '8px'}}/>
                                        </Grid>
                                        <Grid item>
                                          {vendorName}
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                    <TableCell>
                                    <Link component="button" 
                                          variant="body2"
                                          
                                          onClick={this.goTo.bind(this, aUrl)}>
                                      {programName}
                                    </Link>
                                    </TableCell>
                                    <TableCell>{description}</TableCell>
                                    <TableCell>{status}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Paper>}
                    </Grid>
                  </Grid>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </div>
      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }

}

export default withStyles(styleSheet)(PartnerPrograms);
